/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/*========= MENU ==================*/

export default [
  {
    url: '/dashBoard',
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
  },
  {
    url: '/segurados',
    name: 'Associados',
    label: 'Segurados',
    slug: 'page2',
    icon: 'UserIcon',
  },
  {
    url: null,
    name: 'Cotações',
    label: 'Cotações/Propostas',
    slug: 'page2',
    icon: 'ArchiveIcon',
    submenu: [
      {
        url: '/auto/cotacao',
        name: 'Cotações',
        permission: 'Escrita',
        label: 'Novo Auto',
        i18n: 'Checklist',
      },
      {
        url: '/auto/renovacoes',
        name: 'Renovações',
        label: 'Renovações',
        i18n: 'Renovações',
      },
      {
        url: '/auto/endosso',
        name: 'Cotações',
        permission: 'Escrita Endosso',
        label: 'Novo Endosso',
        i18n: 'Checklist',
      },
      {
        url: '/vida/cotacao',
        name: 'Cotações Vida',
        permission: 'Escrita',
        label: 'Novo Vida',
        i18n: 'Checklist',
      },
      {
        url: '/rcvat/cotacao',
        name: 'Cotações RCVAT',
        permission: 'Escrita',
        label: 'Novo RCVAT',
        i18n: 'Checklist',
      },
      {
        url: '/Cotacoes',
        name: 'Cotações',
        label: 'Cotações/Propostas',
        i18n: 'Checklist',
      },
    ],
    hasBadge: true,
    keyBadge: 'cotacoes',
  },
  {
    url: '/Vistorias',
    name: 'Vistorias',
    slug: 'page2',
    icon: 'CameraIcon',
    hasBadge: true,
    keyBadge: 'vistorias',
  },
  {
    url: null,
    name: 'Eventos',
    label: 'Sinistro',
    slug: 'page2',
    icon: 'Minimize2Icon',
    submenu: [
      {
        url: process.env.VUE_APP_URL_OPEN_CLAIM,
        name: 'Aviso de Sinistro',
        label: 'Aviso de Sinistro',
        target: '_blank',
        slug: 'external',
        i18n: 'Aviso de Sinistro',
      },
      {
        url: process.env.VUE_APP_URL_TRACK_CLAIM,
        name: 'Acompanhar Sinistro',
        label: 'Acompanhar Sinistro',
        slug: 'external',
        target: '_blank',
        i18n: 'Acompanhar Sinistro',
      },
      {
        url: '/novo-evento',
        name: 'Eventos',
        permission: 'Escrita',
        label: 'Novo Sinistro',
        i18n: 'Novo Evento',
      },
      {
        url: '/eventos',
        name: 'Eventos',
        permission: 'Escrita',
        label: 'Painel Sinistro',
        i18n: 'Eventos',
      },
      {
        url: '/motivo-sinistro',
        name: 'Motivo de Evento',
        label: 'Motivo de Sinistro',
        i18n: 'Motivo de Evento',
      },
      {
        url: '/situacao-sinistro',
        name: 'Situação de Evento',
        label: 'Situação de Sinistro',
        i18n: 'Situação de Evento',
      },
    ],
  },
  {
    url: null,
    name: 'Financeiro',
    i18n: 'MenuLevel2p2',
    icon: 'DollarSignIcon',
    submenu: [
      {
        url: '/pagamentos',
        name: 'Pagamentos',
        i18n: 'Pagamentos',
      },
      {
        url: '/restituicoes',
        name: 'Restituições',
        i18n: 'Restituições',
      },
      {
        url: '/boletos',
        name: 'Boletos',
        i18n: 'Boletos',
      },
      {
        url: '/fechamento',
        name: 'Fechamento',
        i18n: 'Fechamento',
      },
      {
        url: '/relatorio-parcelas-recebidas',
        name: 'Parcelas Recebidas',
        i18n: 'Parcelas Recebidas',
      },
      {
        url: '/PainelFinanceiro',
        name: 'Painel Financeiro',
        i18n: 'Painel Financeiro',
      },
      {
        url: '/ArquivoRemessa',
        name: 'Arquivo Remessa',
        i18n: 'Arquivo Remessa',
      },
      {
        url: '/ArquivoRetorno',
        name: 'Arquivo Retorno',
        i18n: 'Arquivo Retorno',
      },
      {
        url: '/Extrato',
        name: 'Extrato',
        i18n: 'Extrato',
      },
    ],
  },
  /*=---------- RELATORIOS ----------=*/
  {
    url: null,
    name: 'Relatórios',
    i18n: 'MenuLevel2p2',
    icon: 'BarChartIcon',
    submenu: [
      {
        url: '/Graficos/Crescimento',
        name: 'Crescimento',
        i18n: 'Crescimento',
      },
      {
        url: '/Graficos/Vendas',
        name: 'Vendas',
        i18n: 'Vendas',
      },
      {
        url: '/Graficos/Cancelamentos',
        name: 'Cancelamentos',
        i18n: 'Cancelamentos',
      },
      {
        url: '/Dinamicos',
        name: 'Dinamicos',
        i18n: 'Dinamicos',
      },
      {
        url: '/Consolidado',
        name: 'Consolidado',
        i18n: 'Consolidado',
      },
      {
        url: '/UsoDaContaCorrente',
        name: 'Uso da Conta Corrente',
        i18n: 'Uso da Conta Corrente',
      },
      {
        url: '/comissao',
        name: 'Comissão',
        i18n: 'Comissão',
      },
      {
        url: '/microvida',
        name: 'Microvida',
        i18n: 'Microvida',
      },
      {
        url: '/auto-anual',
        name: 'Auto Anual',
        i18n: 'Auto Anual',
      },
    ],
  },

  /*========= MENU ADMINISTRADOR ==================*/
  {
    header: 'Administrador',
    i18n: 'Apps',
    subPermissions: ['Cadastros', 'Configurações', 'Tabelas'],
  },
  /*=---------- CADASTRO  ----------=*/
  {
    url: null,
    name: 'Cadastros',
    i18n: 'MenuLevel2p2',
    icon: 'PlusSquareIcon',
    submenu: [
      {
        url: '/empresa',
        name: 'Empresa',
        i18n: 'Empresa',
      },
      {
        url: '/pre-cadastro-corretoras',
        name: 'Pré-Cadastro Corretoras',
        label: 'Pré-Cadastro Corretoras',
        i18n: 'Pré-Cadastro Corretoras',
      },
      {
        url: '/usuarios',
        name: 'Usuário',
        i18n: 'Usuário',
      },
      {
        url: '/corretoras',
        name: 'Corretora',
        label: 'Corretoras',
        i18n: 'Corretora',
      },
      {
        url: '/assessorias',
        name: 'Assessoria',
        label: 'Assessorias',
        i18n: 'Assessoria',
      },
      {
        url: '/convenio',
        name: 'Convênio',
        label: 'Convênio',
        i18n: 'Convênio',
      },
      {
        url: '/permissoes',
        name: 'Permissões',
        i18n: 'Permissões',
      },
      {
        url: '/mensageria',
        name: 'Mensageria',
        i18n: 'Mensageria',
      },
      {
        url: '/setores',
        name: 'Setor',
        i18n: 'setor',
      },
      {
        url: '/perfis',
        name: 'Perfil de Usuário',
        i18n: 'Perfil de Usuário',
      },
      {
        url: '/carteiraCobranca',
        name: 'Carteira de Cobrança',
        i18n: 'Carteira de Cobrança',
      },
      {
        url: '/contasBancarias',
        name: 'Contas Bancárias',
        i18n: 'Contas Bancária',
      },
      {
        url: '/fornecedor',
        name: 'Fornecedor',
        i18n: 'Fornecedor',
      },
      {
        url: '/tipoAtendimento',
        name: 'Tipo de Atendimento',
        i18n: 'Tipo de Atendimento',
      },
      {
        url: '/vistoriadores',
        name: 'Vistoriador',
        i18n: 'Vistoriador',
      },
      {
        url: '/recusa-de-proposta',
        name: 'Recusa de Proposta',
        i18n: 'Recusa de Proposta',
      },
    ],
  },
  /*=---------- CONFIGURAÇÕES ----------=*/
  {
    url: null,
    name: 'Configurações',
    i18n: 'MenuLevel2p2',
    icon: 'SettingsIcon',
    submenu: [
      {
        url: '/produtos',
        name: 'Produto',
        i18n: 'Produto',
      },
      {
        url: '/automovel-anual',
        name: 'Automóvel Anual',
        i18n: 'Automóvel Anual',
      },
      {
        url: '/contrato',
        name: 'Contrato',
        i18n: 'Contrato',
      },
      {
        url: '/tipoPagamento',
        name: 'Tipo de Pagamento',
        i18n: 'Tipo de Pagamento',
      },
      {
        url: '/tipoFotos',
        name: 'Tipo de Foto',
        i18n: 'Tipo de Foto',
      },
      {
        url: '/integracoes',
        name: 'Integrações',
        i18n: 'Integrações',
      },
      {
        url: '/anti-fraud',
        name: 'Antifraude',
        i18n: 'Antifraude',
      },
      {
        url: '/agravos',
        name: 'Agravos',
        i18n: 'Agravos',
      },
      {
        url: '/vistoria-previa',
        name: 'Vistoria Prévia',
        i18n: 'Agravos',
      },
      {
        url: '/conta-corrente',
        name: 'Conta Corrente',
        i18n: 'Conta Corrente',
      },
      {
        url: '/edi',
        name: 'Arquivo EDI',
        label: 'EDI',
        i18n: 'EDI',
      },
      {
        url: '/precificacao-auto',
        name: 'Precificação Auto',
        i18n: 'Precificação Auto',
      },
      {
        url: '/blocklist-corretoras',
        name: 'Blocklist Corretoras',
        i18n: 'Blocklist Corretoras',
      },
      {
        url: '/alteracao-de-status',
        name: 'Alteração de Status',
        i18n: 'Alteração de Status',
        permission: 'Escrita',
      },
      {
        url: '/origem-da-cotacao',
        name: 'Origem da Cotação',
        i18n: 'Origem da Cotação',
        permission: 'Escrita',
      },
      {
        url: '/congeneres',
        name: 'Congêneres',
        i18n: 'Congêneres',
        permission: 'Escrita',
      },
      {
        url: null,
        name: 'Endossos',
        i18n: 'Endossos',
        submenu: [
          {
            url: '/endosso-automovel',
            name: 'Endosso Automóvel',
            i18n: 'Endosso Automóvel',
          },
        ],
      },
      {
        url: null,
        name: 'I4Pro',
        i18n: 'I4Pro',
        submenu: [
          {
            url: '/i4pro',
            name: 'I4Pro',
            label: 'Configurações',
            i18n: 'Configurações',
            permission: 'Escrita',
          },
          {
            url: '/i4pro/envio-em-massa',
            name: 'I4Pro',
            label: 'Envio em massa',
            i18n: 'Envio em massa',
            permission: 'Escrita',
          },
        ],
      },
    ],
  },
  /*=---------- TABELAS ----------=*/
  {
    url: null,
    name: 'Tabelas',
    i18n: 'MenuLevel2p2',
    icon: 'ListIcon',
    submenu: [
      {
        url: '/grupoVeiculos',
        name: 'Grupo de Veículos',
        i18n: 'Grupo de Veículos',
      },
      {
        url: '/tabelas',
        name: 'Tabelas',
        i18n: 'Tabelas',
      },
      {
        url: '/blackList',
        name: 'Black List',
        i18n: 'Black List',
      },
      {
        url: '/listRastreadores',
        name: 'Lista Rastreadores',
        i18n: 'Lista Rastreadores',
      },
    ],
  },
];
